export default __webpack_public_path__ + "static/media/StageCurtainRight.0dd2d1ac.svg";